import { NxButton } from "@agent-nexus/ui"

import { Icon } from "@/common/icons/Icon"

const reloadPage = () => window.location.reload()

/** The full-page reload action offered by the `ErrorSurface` states. */
export function ReloadButton({ children }: { children: string }) {
  return (
    <NxButton
      variant="default"
      size="default"
      leftIcon={<Icon name="arrow-rotate-counter-clockwise" size={16} />}
      onClick={reloadPage}
    >
      {children}
    </NxButton>
  )
}
